
import { defineComponent } from 'vue'
import { mapGetters, mapState } from 'vuex'
import AsahiProgress from '@/components/library/AsahiProgress.vue'
import AllertCart from '@/components/library/assets/AllertCart.vue'
import SuccessCart from '@/components/library/assets/SuccessCart.vue'
import BudgetCart from '@/components/library/assets/budget_icon.svg'
import YellowAlert from '@/components/library/assets/yellow_alert.svg'
import WitheWallet from '@/components/library/assets/withe_wallet.svg'
import formatDateMixin from '@/utils/mixin'
import posmMixin from '@/utils/posmMixin'
import { CommonActionType } from '@/store/modules/common/action-type'
import tankMixin from '@/utils/tankMixin'

const HOMEPAGE_URL = '/'

export default defineComponent({
  components: {
    SuccessCart,
    AllertCart,
    AsahiProgress
  },
  mixins: [formatDateMixin],
  props: {
    changeMessageColor: {
      type: Boolean,
      default: false
    },
    messageType: {
      type: String,
      default: 'header'
    },
    mobile: {
      type: Boolean,
      default: false
    },
    isWhite: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      errorWeight: false,
      successWeight: false,
      isComponentVisible: false,
      errorWeightBar: false,
      isMobile: (window.innerWidth <= 768) || (this.messageType === 'mobile'),
      BudgetCart,
      YellowAlert,
      WitheWallet
    }
  },
  setup () {
    const isTankBeerOrder = tankMixin()
    const isPosmOrder = posmMixin()
    return {
      isTankBeerOrder,
      isPosmOrder
    }
  },
  computed: {
    ...mapState('basket', ['id', 'query', 'items', 'paymentMethod', 'shipmentId']),
    ...mapGetters('basket', ['progressBarSuccess', 'showProgressBarMessage']),
    ...mapState('catalog', ['alignment', 'shipTos']),

    progressBar () {
      return this.query?.progress_bar_data
    },

    isHomePge () {
      return this.$route.path === HOMEPAGE_URL
    },
    maxOrderCash () {
      return this.progressBar?.iMaximumOrderCash ?? 0
    },
    grandTotalYourPrice () {
      return this.query?.grand_total_your_price_details?.grand_total_your_price ?? 0
    },
    cashFilledPercentage () {
      return (this.grandTotalYourPrice / this.maxOrderCash) * 100
    },
    differenceResult () {
      return Math.round(this.maxOrderCash - this.grandTotalYourPrice)
    },
    totalCartPallet () {
      return this.progressBar?.iTotalCartPalletQty ?? 0
    },
    minimumOrderPallett () {
      return this.progressBar?.iMinimumOrderPallet ?? 0
    },

    messageColorClass () {
      if (this.changeMessageColor) {
        if (this.progressBarMessage.hasError) {
          return 'border-error-text'
        } else if (this.progressBarMessage.hasSucccess) {
          return 'border-success-text'
        } else if (this.progressBarMessage.hasAlert) {
          return 'border-alert-text'
        } else {
          return 'border-default-text'
        }
      }
      return 'border-default-text'
    },

    isCompactAndFullTruck () {
      return this.messageType === 'compact' && this.progressBar?.isFullTruck === true
    },
    isCompactAndNotFullTruck () {
      return this.messageType === 'compact' && this.progressBar?.isFullTruck === false
    },

    progressBarMessage () {
      if (this.isEmptyTransportType) {
        return this.getEmptyTransportMessage()
      }

      if (this.progressBar?.isFullTruck) {
        return this.getFullTruckMessage()
      }

      if (this.progressBar?.sOutletDeliveryMethod === 'tank_tank') {
        return this.getTankMessage()
      }

      if (this.progressBar?.sOutletDeliveryMethod === 'tank_tank') {
        return this.getTankMessage()
      }

      if (this.isPosmOrder && this.posmBudget !== undefined && this.posmBudget != null) {
        return this.getPosmOrderMessage()
      }

      return this.getStandardOrderMessage()
    },
    progressBarMiniMessage () {
      if (this.isPosmOrder && this.posmBudget != null && this.posmBudget !== undefined) {
        return this.getMiniMessageForPosm()
      } else if (this.progressBar?.isFullTruck || this.isEmptyTruck) {
        return this.getMiniMessageForFullTruck()
      } else if (this.isTankBeerOrder) {
        return this.getMiniMessageForTank()
      } else {
        return this.getMiniMessageForStandardOrder()
      }
    },
    isEmptyTruck (): boolean {
      const emptyTypes = ['emptiesfulltruck_emptiesfulltruck']
      return emptyTypes.includes(this.query?.delivery_method)
    },
    isEmptyTransportType (): boolean {
      const emptyTypes = ['emptiespickup_emptiespickup', 'emptiesfulltruck_emptiesfulltruck']
      return emptyTypes.includes(this.query?.delivery_method)
    },
    isEmptyStandard (): boolean {
      const emptyTypes = ['emptiespickup_emptiespickup']
      return emptyTypes.includes(this.query?.delivery_method)
    },
    user () {
      return this.$store.state.auth.user
    },
    isWHSLUser () {
      const shipToIdFromStorage = this.shipTos[0]?.shiptosapid
      return this.user?.permissionSchema?.some((company) =>
        company.shipToId === shipToIdFromStorage &&
        company.rpDetails[0].rolename.includes('WHS')
      )
    },
    posmBudget (): number {
      return this.$store?.state?.common?.posmBudget ?? 0
    }
  },
  methods: {
    getMiniMessageForTank () {
      const { $t } = this
      const totalLiters = this.query?.total_liters
      if (totalLiters < this.progressBar?.iMinLitersTank) {
        return this.createMiniMessage(
          `${$t('Reach minimum number Liters:')} <b> ${totalLiters} / ${this.progressBar?.iMinLitersTank} l</b>`, true, false
        )
      } else if (totalLiters > this.progressBar?.iMaxLitersTank) {
        return this.createMiniMessage(
          `${$t('Exceeded maximum liters:')} <b>${totalLiters} / ${this.progressBar?.iMaxLitersTank} l</b>`, true, false
        )
      } else {
        return this.createMiniMessage(
        `${$t('minimum order capacity reached')} <b>${totalLiters} l</b>`, false, true
        )
      }
    },
    getEmptyTransportMessage () {
      const { totalCartPallet, minimumOrderPallett, progressBar, $t } = this

      if (totalCartPallet < minimumOrderPallett) {
        return this.message(
        `${$t('Reach minimum number of pallets:')} <b>${totalCartPallet} / ${minimumOrderPallett}</b>`,
        $t('The minimum quantity of pallet has not been reached, please add more goods.'),
        $t('Min Pallets', { n: minimumOrderPallett })
        )
      }

      if (totalCartPallet > progressBar?.iMaximumOrderPallet) {
        return this.message(
          $t('The maximum number of pallets has been exceeded.'),
          $t('The maximum number of pallets has been exceeded.'),
        `${$t('Max')} ${minimumOrderPallett} ${$t('pallets')}`,
        true
        )
      }

      if (totalCartPallet === minimumOrderPallett) {
        return this.message(
        `${$t('Reach minimum number of pallets:')} <b>${totalCartPallet} / ${minimumOrderPallett}</b>`,
        $t('The minimum order capacity has been reached.'),
        '',
        false,
        true
        )
      }

      return this.defaultMessage()
    },

    getTankMessage () {
      const { $t } = this
      const totalLiters = this.query?.total_liters
      if (totalLiters < this.progressBar?.iMinLitersTank) {
        return this.message(
          `${$t('Reach minimum number Liters:')} <b> ${totalLiters} / ${this.progressBar?.iMinLitersTank} l</b>`,
          $t('The minimum number of liters has not yet been reached, please add more goods.'),
          $t('Min Liters'),
          true
        )
      } else if (totalLiters > this.progressBar?.iMaxLitersTank) {
        return this.message(
          `${$t('Exceeded maximum liters:')} <b>${totalLiters} / ${this.progressBar?.iMaxLitersTank} l</b>`,
          $t('The maximum liters of order has been exceeded.'),
          $t('Max Liters', { n: this.progressBar?.iMaxLitersTank }),
          true
        )
      } else {
        return this.message(
        `${$t('minimum order capacity reached')} <b>${totalLiters} l</b>`,
        $t('The minimum order capacity has been reached.'),
        '',
        false,
        true
        )
      }
    },

    getFullTruckMessage () {
      const pb = this.progressBar
      const { totalCartPallet, minimumOrderPallett, $t } = this

      if (totalCartPallet <= 0) {
        return this.message(
        `${$t('Reach minimum number of pallets:')} <b>${totalCartPallet} / ${minimumOrderPallett}</b>`,
        $t('The minimum number of pallets has not yet been reached, please add more goods.'),
        $t('Min Pallets', { n: minimumOrderPallett })
        )
      }

      if (totalCartPallet < pb?.iMinimumOrderPallet && pb?.iTotalCartWeight < pb?.iMinimumOrderWeight) {
        return this.message(
        `${$t('Reach minimum number of pallets:')} <b>${totalCartPallet} / ${minimumOrderPallett}</b>`,
        $t('The minimum number of pallets has not yet been reached, please add more goods.'),
        $t('Min Pallets', { n: minimumOrderPallett }),
        true
        )
      }

      if (pb.iTotalCartWeight > pb.iMaximumOrderWeight) {
        return this.message(
        `${$t('Exceeded maximum weight:')} <b>${pb?.iTotalCartWeight}Kg / ${pb?.iMaximumOrderWeight}Kg</b>`,
        $t('The maximum weight of order has been exceeded.'),
        $t('Max weight', { n: pb.iMaximumOrderWeight }),
        true
        )
      }

      if (totalCartPallet > pb?.iMaximumOrderPallet) {
        return this.message(
          $t('The maximum number of pallets has been exceeded.'),
          $t('The maximum number of pallets has been exceeded.'),
        `${$t('Max')} ${minimumOrderPallett} ${$t('pallets')}`,
        true
        )
      }

      if (
        totalCartPallet >= pb?.iMinimumOrderPallet &&
      totalCartPallet < pb?.iMaximumOrderPallet &&
      pb.iTotalCartWeight < pb.iMinimumOrderWeight
      ) {
        return this.message(
          $t('The minimum weight of order has not been reached'),
          $t('The minimum weight of order has not been reached'),
          '',
          true
        )
      }

      if (
        totalCartPallet === pb?.iMaximumOrderPallet &&
      pb?.iTotalCartWeight <= pb?.iMaximumOrderWeight
      ) {
        return this.message(
        `${$t('Reach minimum number of pallets:')} <b>${totalCartPallet} / ${minimumOrderPallett}</b>`,
        $t('The minimum order capacity has been reached.'),
        '',
        false,
        true
        )
      }

      return this.message(
      `${$t('minimum order capacity reached')} <b>${pb?.iTotalCartWeight}Kg / ${pb?.iMaximumOrderWeight}Kg</b>`,
      $t('The minimum order capacity has been reached.'),
      '',
      false,
      true
      )
    },

    getStandardOrderMessage () {
      const { grandTotalYourPrice, maxOrderCash, $t, totalCartPallet, progressBar, isMobile } = this
      const difference = (maxOrderCash - grandTotalYourPrice).toFixed(2)

      if (grandTotalYourPrice <= 0) {
        return this.message(
        `${$t('Reach minimum order price')} ${this.formatCurrency(maxOrderCash)}`,
        $t('The minimum order capacity has not yet been reached, please add more goods.'),
        `${$t('Min')} ${this.formatCurrency(maxOrderCash)}`
        )
      }

      if (totalCartPallet > progressBar?.iMaximumOrderPallet) {
        return this.message(
          $t('The maximum number of pallets has been exceeded.'),
          $t('The maximum number of pallets has been exceeded.'),
        `${$t('Max')} ${this.minimumOrderPallett} ${$t('pallets')}`,
        true
        )
      }

      if (
        totalCartPallet >= progressBar?.iMinimumOrderPallet &&
      totalCartPallet <= progressBar?.iMaximumOrderPallet &&
      progressBar.iTotalCartWeight < progressBar.iMaximumOrderWeight
      ) {
        return this.message(
          $t('Minimum number of pallets has been reached.'),
          '',
          '',
          false,
          true
        )
      }

      if (grandTotalYourPrice < maxOrderCash) {
        return this.message(
          isMobile
            ? $t('The minimum price of order has not yet been reached, please add more goods.')
            : `${$t('Add more')} <b>${this.formatCurrency(parseFloat(difference))}</b> ${$t('to reach minimum order capacity')}`,
          $t('The minimum order capacity has not yet been reached, please add more goods.'),
        `${$t('Min')} ${this.formatCurrency(maxOrderCash)}`,
        true,
        false,
        `<b>${$t('Add')} ${this.formatCurrency(parseFloat(difference))} ${$t('more.')}</b>`
        )
      }

      if (grandTotalYourPrice > maxOrderCash) {
        const formatted = this.formatCurrency(maxOrderCash)
        return this.message(
          isMobile ? $t('minimum order capacity has been reached') : `<b>${formatted}</b> ${$t('minimum order capacity reached')}`,
          $t('minimum order capacity has been reached'),
          '',
          false,
          true,
        `<b>${formatted}</b> ${$t('reached')}`
        )
      }

      return this.defaultMessage()
    },

    message (title: string, subtitle: string, buttonTitle = '', hasError = false, hasSucccess = false, mobileTitle = '', hasAlert = false, isPosm = false) {
      return { title, subtitle, buttonTitle, hasError, hasSucccess, mobileTitle, hasAlert, isPosm }
    },

    defaultMessage () {
      return { title: '', subtitle: '', buttonTitle: '', hasError: false, hasSucccess: false, mobileTitle: '', hasAlert: false, isPosm: false }
    },
    getMiniMessageForFullTruck () {
      const { totalCartPallet, minimumOrderPallett, progressBar, $t } = this

      if (totalCartPallet <= 0) {
        return this.createMiniMessage(`<b>${totalCartPallet} / ${minimumOrderPallett}</b> ${$t('pallets')}`)
      }

      if (totalCartPallet < progressBar?.iMinimumOrderPallet) {
        return this.createMiniMessage(
        `<b>${totalCartPallet} / ${minimumOrderPallett}</b> ${$t('pallets')}`,
        true
        )
      }

      if (
        totalCartPallet >= progressBar?.iMinimumOrderPallet &&
      totalCartPallet <= progressBar?.iMaximumOrderPallet &&
      progressBar.iTotalCartWeight < progressBar.iMaximumOrderWeight
      ) {
        return this.createMiniMessage(
        `<b>${totalCartPallet} / ${minimumOrderPallett}</b> ${$t('pallets')}`,
        false,
        true
        )
      }

      if (totalCartPallet > progressBar?.iMaximumOrderPallet) {
        return this.createMiniMessage(
        `<b>${totalCartPallet} / ${minimumOrderPallett}</b> ${$t('pallets')}`,
        true
        )
      }

      if (progressBar.iTotalCartWeight > progressBar.iMaximumOrderWeight) {
        return this.createMiniMessage(
        `<b>${progressBar?.iTotalCartWeight}Kg / ${progressBar?.iMaximumOrderWeight}Kg</b>`,
        true
        )
      }

      return this.defaultMiniMessage()
    },
    getMiniMessageForPosm () {
      const budget = this.posmBudget
      const total = this.grandTotalYourPrice || 0
      const mov = this.progressBar?.iMaximumOrderCash || 0
      const { $t } = this
      const items = this.query.items || []
      const diff = mov - total

      if (items.length <= 0) {
        return this.createMiniMessage($t('Add more to reach the minimum order value.', { a: this.formatCurrency(mov) }))
      }

      if (items.length > 0 && budget < mov) {
        return this.createMiniMessage($t('Your budget is below minimum order value, and can no longer be used'))
      }

      if (items.length > 0 && total < mov && budget >= total) {
        return this.createMiniMessage($t('Add more POSM', { v: this.formatCurrency(diff) }))
      }

      if (items.length > 0 && total >= mov && (budget - total) >= mov) {
        return this.createMiniMessage($t('Reached', { v: this.formatCurrency(budget) }))
      }

      if (items.length > 0 && total >= mov && budget < total) {
        return this.createMiniMessage($t('Budget exceeded Adjust your cart to pay with budget'))
      }

      if (items.length > 0 && total >= mov && (budget - total) < mov) {
        return this.createMiniMessage($t('You can finish this order, but won’t have enough credit for the next one'))
      }

      return this.defaultMiniMessage()
    },

    getMiniMessageForStandardOrder () {
      const { grandTotalYourPrice, maxOrderCash, $t, totalCartPallet, progressBar } = this
      const difference = (maxOrderCash - grandTotalYourPrice).toFixed(2)

      if (this.isTankBeerOrder) {
        return this.createMiniMessage(
        `${$t('Reach minimum order liters')} ${this.progressBar?.iMinLitersTank}`
        )
      }

      if (grandTotalYourPrice <= 0) {
        return this.createMiniMessage(
        `${$t('Reach minimum order price')} ${this.formatCurrency(maxOrderCash)}`
        )
      }

      if (
        totalCartPallet >= progressBar?.iMinimumOrderPallet &&
      totalCartPallet <= progressBar?.iMaximumOrderPallet &&
      progressBar.iTotalCartWeight < progressBar.iMaximumOrderWeight
      ) {
        return {
          title: $t('Minimum number of pallets has been reached.'),
          subtitle: '',
          hasError: false,
          hasSucccess: true
        }
      }

      if (grandTotalYourPrice < maxOrderCash) {
        return {
          title: `${$t('Add')} <b>${this.formatCurrency(parseFloat(difference))}</b> ${$t('more.')}`,
          subtitle: $t('The minimum order capacity has not yet been reached, please add more goods.'),
          hasError: true,
          hasSucccess: false
        }
      }

      if (grandTotalYourPrice > maxOrderCash) {
        return {
          title: `<b>${this.formatCurrency(maxOrderCash)}</b> ${$t('reached')}`,
          subtitle: $t('Minimum order price reached'),
          hasError: false,
          hasSucccess: true
        }
      }

      return this.defaultMiniMessage()
    },

    createMiniMessage (title: string, hasError = false, hasSucccess = false) {
      return { title, hasError, hasSucccess }
    },

    defaultMiniMessage () {
      return { title: '', subtitle: '', hasError: false, hasSucccess: false }
    },
    getFillPercentage () {
      let fillPercentage = 0
      if (this.isEmptyTransportType) {
        const currentValue = this.progressBarMessage.hasSucccess ? this.progressBar?.iMaximumOrderPallet : this.progressBar?.iTotalCartPalletQty
        fillPercentage = currentValue / this.progressBar?.iMaximumOrderPallet * 100
      } else if (this.isTankBeerOrder) {
        fillPercentage = this.query?.total_liters / this.progressBar?.iMinLitersTank * 100
      } else if (!this.progressBar?.isFullTruck) {
        fillPercentage = this.grandTotalYourPrice / this.maxOrderCash * 100
      } else {
        const currentValue = this.progressBarMessage.hasSucccess ? this.progressBar.iMaximumOrderPallet : this.progressBar.iTotalCartPalletQty
        fillPercentage = currentValue / this.progressBar.iMaximumOrderPallet * 100
      }
      this.emitRequirementStatus()
      return fillPercentage
    },
    emitRequirementStatus () {
      const requirementMessage = this.progressBarMessage.buttonTitle
      this.$emit('requirement-status', requirementMessage)
    },
    emptiesDeliveryMethod () {
      const deliveryMethod = localStorage.getItem('shippingMethod')
      if (deliveryMethod === 'emptiespickup_emptiespickup') {
        return true
      }
    },
    handleProgressBarChange (newProgressBar: any) {
    // Logic when progressBar changes or on mount
      if (newProgressBar) {
        console.log('Progress Bar Data:', newProgressBar)
      }
    },
    fetchPosmBudget () {
      const shipToId = localStorage.getItem('shipToId')
      this.$store.dispatch(CommonActionType.FETCH_BUDGET_POSM, { shipToId })
    },
    getPosmOrderMessage () {
      const budget = this.posmBudget
      const total = this.grandTotalYourPrice || 0
      const mov = this.progressBar?.iMaximumOrderCash || 0
      const { $t } = this
      const items = this.query.items || []
      const diff = mov - total

      if (items.length <= 0) {
        return this.message($t('Add more to reach the minimum order value.', { a: this.formatCurrency(mov) }), $t('The minimum order capacity has not yet been reached, please add more goods.'), '', false, false, '', false)
      }

      if (items.length > 0 && budget < mov) {
        return this.message($t('Your budget is below minimum order value, and can no longer be used'), $t('Your budget does not reach the minimum order value. You can still pay with your standard method'), '', false, false, '', true)
      }

      if (items.length > 0 && total < mov && budget >= total) {
        return this.message($t('Add more to reach the minimum order value.', { a: this.formatCurrency(diff) }), $t('The minimum order capacity has not yet been reached, please add more goods.'), '', true)
      }

      if (items.length > 0 && total >= mov && (budget - total) >= mov) {
        return this.message($t('You have reached the minimum order value', { a: this.formatCurrency(budget) }), $t('The minimum order capacity has been reached.'), '', false, true)
      }

      if (items.length > 0 && total >= mov && budget < total) {
        return this.message($t('Budget exceeded Adjust your cart to pay with budget'), $t('To complete your free order, adjust your cart, or pay with your standard method'), '', false, false, '', true)
      }

      if (items.length > 0 && total >= mov && (budget - total) < mov) {
        return this.message($t('After completing the order, the remaining credit won’t be sufficient for another order'), $t('After completing this order, you will be left with credit that will no longer be enough for another free order'), '', false, false, '', true)
      }

      return this.message('', '', '')
    }

  },
  mounted () {
    this.handleProgressBarChange(this.progressBar)
    if (this.isPosmOrder) {
      this.fetchPosmBudget()
    }
  },
  watch: {
    progressBar (newVal) {
      this.handleProgressBarChange(newVal)
    },
    isPosmOrder (nextVal, prevVal) {
      if (nextVal && !prevVal) {
        this.fetchPosmBudget()
      }
    }
  }
})
